import styled from 'styled-components';

import { Row } from 'components';

export const Wrapper = styled(Row)`
  align-items: center;
`;
